<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      <span (click)="closeDialog()" class="material-symbols-outlined float-right text-red">
        close
      </span>
      <span style="font-size: 20px;">Login</span>
    </div>
    <div class="card-body p-3">
      <form [formGroup]="loginForm" class="bg-black p-3">
        <p
          *ngIf="errorMsg"
          class="alert alert-danger alert-dismissible fade show"
        >
          {{ errorMsg }}
        </p>
        <div class="form-group">
          <label class="form-control-label">Username</label>
          <input
            type="text"
            class="form-control"
            formControlName="username"
            placeholder="Enter username"
          />
          <span
            class="text-danger"
            *ngIf="
                (loginFormControl.username.touched || submitted) &&
                loginFormControl.username.errors?.required
              "
          >
              Username is required
            </span>
        </div>
        <div class="form-group">
          <label class="form-control-label">Password</label>
          <input
            type="password"
            class="form-control"
            formControlName="password"
            placeholder="Enter Password"
          />
          <span
            class="text-danger"
            *ngIf="
                (loginFormControl.password.touched || submitted) &&
                loginFormControl.password.errors?.required
              "
          >
              Password is required
            </span>
        </div>

        <div class="form-group">
          <div class="d-flex">
            <input type="checkbox" value="agree" id="customCheck" formControlName="terms" class="checkbox" [(ngModel)]="isagree">
            <label for="customCheck" class="green-link">
            I am at least <a href="javascript:void(0)" class="text-danger" role="button">18 years</a>
            of age and I have read, accept and agree to the

            <a routerLink="/dashboard/terms" class="" target="_blank">Terms and Conditions </a>,
            <a routerLink="/dashboard/privacypolicy" class="" target="_blank">Responsible Gaming </a>
            </label>
          </div>
        </div>

        <div class="col-lg-12 loginbttm p-0">
          <div class="col-lg-6 login-btm login-text">
            <!-- Error Message -->
          </div>
          <div
            style="text-align: center"
            (click)="login()"
            class="col-lg-12 login-btm login-button p-0"
          >
            <button
              type="button"
              style="width: 100%;text-align: center; background: #0e684e;  color: #fff;"
              class="btn btn-block mt-3"
            >
              Login
            </button>
            <small>This site is protected by reCAPTCHA and the Google <span class="green-link"><a href="https://policies.google.com/privacy">Privacy Policy</a></span> and <span class="green-link"><a href="https://policies.google.com/terms">Terms of Service</a></span> apply.</small>
          </div>
<!--          <div-->
<!--          style="text-align: center"-->
<!--          (click)="demologin()"-->
<!--          class="col-lg-12 login-btm login-button"-->
<!--        >-->
<!--          <button-->
<!--            type="button"-->
<!--            style="width: 100%;text-align: center;"-->

<!--            class="btn btn-success rounded-pill mt-3"-->
<!--          >-->
<!--            Login With Demo-->
<!--          </button>-->
<!--         </div>-->
        </div>
      </form>
    </div>
  </div>
</div>
